import { createSlice } from "@reduxjs/toolkit";
import { rechargeManagementReducer } from "../extraReducers/rechargeManagementReducer";

// 定义初始化数据
const initialState = {
  rechargeSettingConfig: {} as any,
  rechargeLine: {} as any,
  bankList: [] as any[],
  rechargeMoney: [] as any,
  rechargeRecord: {} as any,
  tauditList: {} as any,
  remitList: {} as any,
  payedList: {} as any,
  notPayedList: {} as any,
  bankCardInform: {} as any,
  remitCardInform: {} as any,
};

const rechargeManagementSlice = createSlice({
  name: "rechargeManagement",
  initialState,
  reducers: {},
  extraReducers: rechargeManagementReducer,
});

// 默认导出,到处的文件需要在store入口文件引入
export default rechargeManagementSlice.reducer;
